import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import * as Constants from "../../../data/StringConstants";
import { FoldersApi } from "../../../api/folders/folders";
import FoldersTable from "../../../components/Table/FoldersTable";
import CustomToolbar from "./ArchivedFoldersTableToolbar";
import { getTableOptions } from "../../../components/Table/foldersTableUtilities";
import AppContext from "../../../data/AppContext";

/**
 * This container is responsible for data fetching and rendering of corresponding sub-components
 * for the 'Archived Folders' view which lists promotions (folders) for an organization that have
 * been archived by a user.
 */
export default function ArchivedFoldersContainer(props) {
	const folderState = { data: [], totalItemCount: 0, isLoading: true };
	const [resp, setData] = useState(folderState);
	const shownFolderCount = 100;
	const history = useHistory();
	const user = useContext(AppContext).user;
	useEffect(() => {
		let isCancelled = false;

		FoldersApi.fetchAllArchivedFoldersForAnOrg()
			.then(resp => {
				const newState = {
					data: resp.data,
					totalItemCount: resp.data.length,
					isLoading: false
				};
				!isCancelled && setData(newState);
			})
			.catch(err => console.log(Constants.NO_FOLDERS_RESP_ERR, err));

		return () => (isCancelled = true);
	}, []);

	return resp.isLoading ? (
		<LoadingSpinner />
	) : (
		<FoldersTable
			data={resp.data}
			shownFolderCount={shownFolderCount}
			tableOptions={tableOptionsForArchivedFolders(
				shownFolderCount,
				history,
				resp,
				setData,
				user,
				props.matchedComponentName
			)}
			{...props}
		/>
	);
}

ArchivedFoldersContainer.propTypes = {
	userId: PropTypes.number
};

/**
 * Updates the default Folder table options with additional options for
 * FolderTable in Archived Smart View.
 * @param {int} shownFolderCount
 * @param {obj} history
 */
export function tableOptionsForArchivedFolders(
	shownFolderCount,
	history,
	resp,
	setData,
	user,
	matchedComponentName
) {
	const options = getTableOptions(shownFolderCount, history, matchedComponentName);

	if (hasUnarchivePermission(user)) {
		options.selectableRows = "multiple";
		options.selectableRowsOnClick = true;
		options.selectableRowsHeader = false;
		options.customToolbarSelect = (selectedRows, displayData) => {
			return (
				<CustomToolbar
					selectedRows={selectedRows}
					displayData={displayData}
					resp={resp}
					setData={setData}
				/>
			);
		};
	} else {
		options.selectableRows = "none";
		options.selectableRowsOnClick = false;
	}

	//Remove conflicting options
	delete options["onRowClick"];

	return options;
}

/**
 * Returns true if user has more than Viewer permission.
 * @param {*} user
 */
function hasUnarchivePermission(user) {
	return (
		user.isEditor ||
		user.isPublisher ||
		user.isAdmin ||
		user.isGlobalEdit ||
		user.isGlobalAdmin ||
		user.isGlobalHelp
	);
}
